export async function fetchWithAuth(url, options = {}, onLogout) {
    try {
        const stored = localStorage.getItem("user");
        const user = stored ? JSON.parse(stored) : null;
        const isJson = typeof options.body === "string" && options.body.trim().startsWith("{");
        
        const accessToken = user?.accessToken;

        const defaultHeaders = {
            ...(options.headers || {}),
            ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
            ...(isJson ? { "Content-Type": "application/json" } : {}),
        };

        const config = {
            ...options,
            headers: defaultHeaders,
            credentials: "include",
        };

        let response = await fetch(url, config);

        if (response.status === 401) {
            try {
                const refresh = await fetch(`${process.env.REACT_APP_API_URL}/auth/refresh`, {
                    method: "POST",
                    credentials: "include",
                });

                if (!refresh.ok) {
                    console.error('Ошибка обновления токена:', await refresh.text());
                    if (onLogout) onLogout();
                    throw new Error("Refresh не удался");
                }

                const data = await refresh.json();
                const newAccessToken = data.accessToken;

                const updatedUser = { ...user, accessToken: newAccessToken };
                localStorage.setItem("user", JSON.stringify(updatedUser));

                const retryConfig = {
                    ...options,
                    headers: {
                        ...defaultHeaders,
                        Authorization: `Bearer ${newAccessToken}`,
                    },
                    credentials: "include",
                };

                response = await fetch(url, retryConfig);
            } catch (err) {
                console.error('Ошибка при обновлении токена:', err);
                localStorage.removeItem("user");
                if (onLogout) onLogout();
                throw err;
            }
        }

        if (!response.ok) {
            const errorText = await response.text();
            console.error(`Ошибка запроса ${url}:`, errorText);
            throw new Error(errorText);
        }

        return response;
    } catch (error) {
        console.error('Ошибка в fetchWithAuth:', error);
        throw error;
    }
}

